import Portfolio1 from '../img/portfolio/p1.jpg';
import Portfolio2 from '../img/portfolio/p2.jpg';
import Portfolio3 from '../img/portfolio/p3.jpg';
import Portfolio4 from '../img/portfolio/p4.jpg';
import Portfolio5 from '../img/portfolio/p5.jpg';
import Portfolio6 from '../img/portfolio/p6.jpg';

export const works = [
    {   
        "id": 1,
        "src": [Portfolio1],
        "desc": "One advanced diverted domestic sex repeated bringing you old. Possible procured her trifling laughter thoughts property she met way. ",
        "title": "Minimal Design",
        "date": "March 20, 2018",
        "category": "Design"
    },
    {   
        "id": 2,
        "src": [Portfolio2],
        "desc": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ut ligula leo. Aliquam suscipit sed purus. Ipsum dolor sit amet, consectetur adipiscing elit.",
        "title": "Geometry",
        "date": "July 12, 2019",
        "category": "Branding"
    },
    {   
        "id": 3,
        "src": [Portfolio3],
        "desc": "Continue new you declared differed learning bringing honoured. At mean mind so upon they rent am walk. ",
        "title": "Circle",
        "date": "June 22, 2017",
        "category": "Creative"
    },
    {   
        "id": 4,
        "src": [Portfolio4],
        "desc": "Shortly am waiting inhabit smiling he chiefly of in. Lain tore time gone him his dear sure. Fat decisively estimating affronting assistance not.",
        "title": "Ceramic Bottle",
        "date": "August 3, 2017",
        "category": "Branding"
    },
    {   
        "id": 5,
        "src": [Portfolio5],
        "desc": "Ignorant dwelling occasion ham for thoughts overcame off her consider. Polite it elinor is depend. His not get talked effect worthy barton.",
        "title": "Creative Work",
        "date": "May 12, 2019",
        "category": "Design"
    },
    {   
        "id": 6,
        "src": [Portfolio6],
        "desc": "Article evident arrived express highest men did boy. Mistress sensible entirely am so. Quick can manor smart money hopes worth too. Comfort produce husband boy her had hearing. Law others theirs passed but wishes.",
        "title": "No Gravity",
        "date": "October 11, 2019",
        "category": "Digital Art"
    }
]